<template>
  <div style="padding: 5px; line-height: 1.5em">
    <div class="bigNum" v-bind:style="{color: color}">
      <span ref="number"></span>
      <div ref="percent" style="font-size: small; display: inline; vertical-align: bottom;">
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import {CountUp} from 'countup.js'

export default {
  name: 'bigNum',
  data: function (){
    return {
      countUpNumber: undefined,
      countUpPercent: undefined,
    }
  },
  props: [
    'format',
    'num',
    'formatPercent',
    'numPercentNum',
    'color',
  ],
  mounted() {
    this.countUpNumber = new CountUp(this.$refs.number, this.num, {formattingFn: this.format, duration: 1})
    this.countUpPercent = new CountUp(this.$refs.percent, this.numPercentNum, {formattingFn: (f) => ' ('+ this.formatPercent(f) + '%)', decimalPlaces: 4, duration: 1})
  },
  watch: {
    num: function () {
      if (this.countUpNumber) {
        let num_digits = this.num.toString().length
        if (num_digits <= 3) {
          this.countUpNumber.formattingFn = (f) => f
          this.countUpNumber.update(this.num)
        } else {
          this.countUpNumber.formattingFn = this.format
          this.countUpNumber.update(this.num)
        }
      }
    },
    numPercentNum: function () {
      if (this.countUpPercent) {
        this.countUpPercent.update(this.numPercentNum)
      }
    },
  },
}
</script>

<style scoped>

.bigNum {
  font-size: xx-large;
  font-weight: bolder;
}

</style>
